// Slice de gestion du theme etcrm
var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    theme: null,
    variant: "",
    variables: {},
    themeSettings: {},
    colorBase: "",
    underlineColor: "",
    midColor: "",
    endColor: "",
    fontOpacity: {},
    bgImage: {},
    colors_palette: {},
    hasDefault: true,
};
export var themeSliceState = createSlice({
    name: "theme",
    initialState: initialState,
    reducers: {
        updateTheme: function (state, action) {
            var _a = action.payload, variant = _a.variant, theme = _a.theme;
            if (theme) {
                state.theme = theme;
            }
            if (variant) {
                state.variant = variant;
            }
        },
        updateThemeSettings: function (state, action) {
            var _a = action.payload, colorBase = _a.colorBase, underlineColor = _a.underlineColor, midColor = _a.midColor, endColor = _a.endColor, fontOpacity = _a.fontOpacity, bgImage = _a.bgImage, colors_palette = _a.colors_palette, hasDefault = _a.hasDefault;
            if (colorBase) {
                state.colorBase = colorBase;
            }
            if (underlineColor) {
                state.underlineColor = underlineColor;
            }
            if (midColor) {
                state.midColor = midColor;
            }
            if (endColor) {
                state.endColor = endColor;
            }
            if (fontOpacity) {
                state.fontOpacity = fontOpacity;
            }
            if (colors_palette) {
                state.bgImage = colors_palette;
            }
            if (bgImage) {
                state.bgImage = bgImage;
            }
            if (typeof hasDefault === "boolean") {
                state.hasDefault = hasDefault;
            }
        },
        setThemeVariables: function (state, action) {
            state.variables = action.payload;
        },
    },
});
export var updateTheme = (_a = themeSliceState.actions, _a.updateTheme), setThemeVariables = _a.setThemeVariables, updateThemeSettings = _a.updateThemeSettings;
export default themeSliceState.reducer;
